module.exports = __webpack_public_path__ + "img/success.daf85668.png";